import { TIME_SECONDS_FORMAT, momentJP } from './timer';
import moment from 'moment';
moment.locale('ja');
import { currencyFormat } from 'js/utils/helpers/number';

// http://shop-orderr.local/shop-manage-or/send-otp?type=register
// string
export const SEND_OTP_TYPE = {
  isRegister: 'register',
  isForgot: 'forgot-password',
};

export const makeRandomId = (length) => {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*_=';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const IS_FORGOT_PASSWORD_KEY = 'is-forgot-password';

export const PUB_SUB_KEY = {
  DEACTIVE_SHOP: 'deactive_shop',
  RING_ALARM: 'RING_ALARM',
  RING_CHIP_MENU_ORDER_ALARM: 'RING_CHIP_MENU_ORDER_ALARM',
  // Refresh orderGroups data
  KEY_FRESH_UPDATE_ORDER: 'publishKeyFreshUpdatedOrders',
  KEY_FRESH_NEW_ORDER: 'publishKeyFreshNewOrderData',
  KEY_FRESH_PAYMENT_ORDERGROUP: 'publishKeyFreshPaymentData',
};

export const ALARM_AUDIO_PATH = `${process.env.MIX_ASSETS_PATH}sounds/audiostock_16791.wav`;
export const CHIP_MENU_ORDER_AUDIO_PATH = `${process.env.MIX_ASSETS_PATH}sounds/audiostock_chip_menu_order.wav`;

export const ENTER_KEY_CODE = 13;

export const MENU_STATUS = {
  STATUS_ONSALE: 'onsale',
  STATUS_OFFSALE: 'not_onsale',
};

export const ORDER_HISTORY_PAGINATION = 20;

export const CHARCODE_NUMBER_ZERO = 48;

export const CHARCODE_NUMBER_NINE = 57;

export const CHARCODE_MINUS = 45;

export const getPositiveNumber = (value) => {
  return Number(value) === 0
    ? value.replace(/[^1-9]/g, '').replace(/(\..*?)\..*/g, '$1')
    : value.replace(/[^0-9]/g, '').replace(/(\..*?)\..*/g, '$1');
};

export const round = (number, decimals) => {
  decimals = decimals || 0;

  return Math.round((number * Math.pow(10, decimals))) / Math.pow(10, decimals);
};

export const roundUp = (number, decimals) => {
  decimals = decimals || 0;

  return Math.ceil((number * Math.pow(10, decimals))) / Math.pow(10, decimals);
};

export const roundDown = (number, decimals) => {
  decimals = decimals || 0;

  return Math.floor((number * Math.pow(10, decimals))) / Math.pow(10, decimals);
};

export const showtaxValue = (value, currencyName, isShowAttachText = true) => {

  return isShowAttachText
    ? `(内消費税額 ${value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}${currencyName})`
    : `${value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}${currencyName}`;
};

export const TAX_OPTIONS = [
  {
    tax_rate: 0.1,
    name: '標準課税',
  },
  {
    tax_rate: 0.08,
    name: '軽減課税',
  },
  {
    tax_rate: 0,
    name: '非課税',
  },
];

export const ROUND_DOWN = 0;

export const ROUND_UP = 1;

export const hanldePriceFractionMode = (value, decimals, roundType) => {
  switch(roundType) {
    case ROUND_DOWN:
      return roundDown(value, decimals)
    case ROUND_UP:
      return roundUp(value, decimals)
    default:
      return round(value, decimals)
  }
};

export const CURRENCY_UNIT = [5, 10, 50, 100, 500, 1000, 2000, 5000, 10000];

export const S3_URL = process.env.MIX_AWS_S3_BUCKET
  ? `https://${process.env.MIX_AWS_S3_BUCKET}/`
  : `${window.location.origin}/`;

export const TIME_WAITING_FOR_RESEND = 60000;

export const ON_BOARDING_CONFIG = {
  USER_GROUP_ID: {
    CUSTOMER: 'customer',
    SHOP: 'shop',
  },
  USER_GROUP_NAME: {
    CUSTOMER: '顧客',
    SHOP: '店舗',
  },
};

export const formatPriceWhileTyping = (num) => {
  let output = parseFloat(String(num).replace(/,/g, ''));

  return !isNaN(output) ? String(output).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : '';
};

export const INITIAL_ORDER_FLG_OFF = 0;

export const HOURS_PRICE_FLG_ON = 1;

export const getHourPriceNearestNow = (menu) => {
  const now = moment(momentJP().format('HH:mm:ss'), TIME_SECONDS_FORMAT);
  let hourPrice = null;
  if (menu?.m_shop_business_hour_prices?.length) {
    hourPrice = menu?.m_shop_business_hour_prices?.filter(block => {
      if (block?.m_shop_business_hour) {
        const blockStartTime = moment(block.m_shop_business_hour.start_time, TIME_SECONDS_FORMAT);
        const blockFinishTime = moment(block.m_shop_business_hour.finish_time, TIME_SECONDS_FORMAT);

        return blockStartTime < now && now < blockFinishTime && block?.display_flg === HOURS_PRICE_FLG_ON;
      }

      return false;
    });
  }

  return hourPrice?.length ? currencyFormat(Number(hourPrice[0]?.price)) : null;
};

export const NO_IMAGE_URL = 'img/shared/noimage.png';

export const DEFAULT_AVATAR_URL = 'img/shared/default-avatar.png';

export const OFF_WORK_VALUE = 0;

export const WORK_VALUE = 1;

export const THANK_FUNCTION_FLG_OFF = 0;

export const THANK_FUNCTION_FLG_ON = 1;

export const CHIP_MENU_TYPE = 'chip';

export const DEFAULT_CARD_LENGTH = 16;

export const MAX_WIDTH_AFTER_RESIZE = 1000;

export const MAX_HEIGHT_AFTER_RESIZE = 1000;

export const MAX_SIZE_FILE_MB_UNIT = 10;

export const KB_UNIT_TO_BYTE = 1000;

export const reduceImageFileSize = async (base64Str, maxWidth = MAX_WIDTH_AFTER_RESIZE, maxHeight = MAX_HEIGHT_AFTER_RESIZE) => {
  let resized_base64 = await new Promise((resolve) => {
    let img = new Image()
    img.src = base64Str
    img.onload = () => {
      let canvas = document.createElement('canvas')
      let width = img.width
      let height = img.height

      if (width > height) {
        if (width > maxWidth) {
          height *= maxWidth / width
          width = maxWidth
        }
      } else {
        if (height > maxHeight) {
          width *= maxHeight / height
          height = maxHeight
        }
      }
      canvas.width = width
      canvas.height = height
      let ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, width, height)
      resolve(canvas.toDataURL())
    }
  });

  return resized_base64;
}
export const isServicePlanFree = (servicePlan) => servicePlan?.price == 0;

export const ORDERGROUP_SUMMARY_MODE = { 
  DAILY : {
    NAME : 'daily',
    LABEL: '日別',
  },
  HOURLY : {
    NAME : 'hourly',
    LABEL: '時間別',
  }
};
